import { FaTools } from "react-icons/fa";
import { TOOL_ITEMS } from "./_Navigation";
import { ToolsDashboardViewMain, ToolsWorkbenchViewMain } from "../Components/ToolsViewMain";

export const ToolsModule = () => [
    {
        views: "PRIVATE", path: "/tools", component: <ToolsDashboardViewMain />,
        roles: null, permissions: null, label: "Herramientas", icon: <FaTools />,
        displayInHeader: false, displayInFooter: false, displayInSidebar: false,
        isBlockedWhenLogged: false,
    },
    ...TOOL_ITEMS.map((tool) => ({
        views: "PRIVATE", path: tool.path, component: <ToolsWorkbenchViewMain tool={tool.value} />,
        roles: null, permissions: null, label: tool.label, icon: <FaTools />,
        displayInHeader: false, displayInFooter: false, displayInSidebar: false,
        isBlockedWhenLogged: false,
    })),
];
